import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthResourceServerErrorHandler } from "angular-oauth2-oidc";
import { Observable, of, throwError } from "rxjs";
import { Logger } from "../../services/logger.service";

const log = new Logger('OAuthServerErrorHandler');

export class OAuthServerErrorHandler implements OAuthResourceServerErrorHandler {

    private router = inject(Router);

    constructor() {
    }

    handleError(err: HttpResponse<any>): Observable<any> {
        if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
                log.info('Received a 401 response, redirecting to landing page');
                this.router.navigateByUrl('/should-login');
            }

            return throwError(() => err)
        }
        
        return of(err);
    }
}